module.exports = __webpack_public_path__ + "img/3.cleaned_shower.c6726aea.svg";